export default "__VITE_ASSET__AntrwYZ4__"